import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    translations: {},
    loading: {},
    errors: {},
};

const translateSlice = createSlice({
    name: 'translate',
    initialState,
    reducers: {
        clearTranslation: (state, action) => {
            const key = action.payload;
            delete state.translations[key];
            delete state.loading[key];
            delete state.errors[key];
        },
        clearAllTranslations: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                (action) => action.type === 'common/translateText/pending',
                (state, action) => {
                    const key = action.meta?.arg?.cacheKey;
                    if (key) {
                        state.loading[key] = true;
                        state.errors[key] = null;
                    }
                },
            )
            .addMatcher(
                (action) => action.type === 'common/translateText/fulfilled',
                (state, action) => {
                    const key = action.meta?.arg?.cacheKey;
                    if (key) {
                        state.loading[key] = false;
                        state.translations[key] = {
                            translatedText: action.payload?.translatedText,
                            sameLanguage: action.payload?.sameLanguage || false,
                        };
                    }
                },
            )
            .addMatcher(
                (action) => action.type === 'common/translateText/rejected',
                (state, action) => {
                    const key = action.meta?.arg?.cacheKey;
                    if (key) {
                        state.loading[key] = false;
                        state.errors[key] =
                            action.payload || 'Translation error';
                    }
                },
            );
    },
});

export const { clearTranslation, clearAllTranslations } =
    translateSlice.actions;

const getTranslateState = (state) => {
    return state.commonData.translate || state.translate || {};
};

export const selectTranslation = (cacheKey) => (state) => {
    if (!cacheKey) return null;
    return getTranslateState(state).translations?.[cacheKey] || null;
};

export const selectTranslationLoading = (cacheKey) => (state) => {
    if (!cacheKey) return false;
    return getTranslateState(state).loading?.[cacheKey] || false;
};

export const selectTranslationError = (cacheKey) => (state) => {
    if (!cacheKey) return null;
    return getTranslateState(state).errors?.[cacheKey] || null;
};

export const translate = translateSlice.reducer;
